import React from 'react'
import {Helmet} from "react-helmet"
const MetaData = ({metaTitle, metaDescription, robots = "index, follow"}) => {
  return (
    <>
           <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="robots" content={robots} />
      </Helmet>
    </>
  )
}

export default MetaData
